import React, {useRef, useState, useCallback} from 'react';
import { faDownload } from '@fortawesome/pro-regular-svg-icons';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  IconButton,
} from '@mui/material';
import Button from 'src/components/era-package/forms/Button';
import Buttons from 'src/components/era-package/era/Buttons';
import SnackBar from 'src/components/era-package/era/SnackBar';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import pathMap from 'src/paths/pathMap';
import { generatePath } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faAngleRight as nextIcon, faSpinnerThird, faTimes} from '@fortawesome/pro-regular-svg-icons';
import EditEntrySummary from './entry-form/edit/EditEntrySummary';
import Print7501FormModal from './entry-form/edit/Print7501FormModal';
import Print3461FormModal from './entry-form/edit/Print3461FormModal';
import AbiEntrySummaryApiUrls from "../../../apiUrls/AbiEntrySummaryApiUrls";

export const DetailModal = ({
  onClose, id, fetchData, rowData, ...props
}) => {
  const dialogRef = useRef(null);
  const history = useHistory()

  const [loading, setLoading] = useState(false);
  const [print7501Loading, setPrint7501Loading] = useState(false);
  const [print3461Loading, setPrint3461Loading] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openPrint7501Dialog, setOpenPrint7501Dialog] = useState(false);
  const [openPrint3461Dialog, setOpenPrint3461Dialog] = useState(false);
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [print7501FormData, setPrint7501FormData] = useState({});
  const [print3461FormData, setPrint3461FormData] = useState({});


  const handleClose = (...args) => {
    if (typeof onClose === 'function')
      onClose(...args)
  }

  const handleEdit = () => {
    handleClose();
    history.push(generatePath(pathMap.ABI_ENTRY_SUMMARY_EDIT_VIEW, { id }));
  };
  
  const handleClone = () => {

    setLoading(true);

    // BACKEND TODO: clone the item with provided `id` and generate a new ID
    fetch(AbiEntrySummaryApiUrls.CLONE+`?abiTransId=${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
      },
    }).then(res => res.json())
        .then(json => {
          setLoading(false);
          if (!!json.data) {
            handleClose();
            history.push(generatePath(pathMap.ABI_ENTRY_SUMMARY_EDIT_VIEW, { id: json.data.abiTransId }));
          }
        })
        .catch(err => {
          setLoading(false);
          console.error(err);
        })
  }

  const handleDeleteDialog = () => {
    setOpenDeleteDialog(true)
  }
  
  const handlePrint7501Dialog = useCallback(async () => {
    try {
	  const data = await fetchPrint7501Data(id);
   	  setOpenPrint7501Dialog(true)
      setPrint7501FormData(data);
      return data;
    } catch (error) {
      console.error('Error refreshing line items:', error);
    }
  }, [id, setPrint7501FormData]);
  
  const handlePrint3461Dialog = useCallback(async () => {
    try {
	  const data = await fetchPrint3461Data(id);
   	  setOpenPrint3461Dialog(true)
      setPrint3461FormData(data);
      return data;
    } catch (error) {
      console.error('Error refreshing line items:', error);
    }
  }, [id, setPrint3461FormData]);
  
  const fetchPrint7501Data = async (abiTransId) => {
	  	  console.log("fetchPrint7501Data");

	const response = await fetch(`${AbiEntrySummaryApiUrls.GET_FORM_7501_PRINT_OPTIONS}?abiTransId=${abiTransId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken')),
      },
    });
    const json = await response.json();
    console.log(json);
    console.log(json.data);
    return json.data;
  };

  const fetchPrint3461Data = async (abiTransId) => {
	  console.log("fetchPrint3461Data");
	  console.log(`${AbiEntrySummaryApiUrls.GET_FORM_3461_PRINT_OPTIONS}`);
	const response = await fetch(`${AbiEntrySummaryApiUrls.GET_FORM_3461_PRINT_OPTIONS}?abiTransId=${abiTransId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken')),
      },
    });
    const json = await response.json();
    console.log(json);
    console.log(json.data);
    return json.data;
  };
  
  const closePrint7501Dialog = () => {
    setOpenPrint7501Dialog(false)
  }
  
  const closePrint3461Dialog = () => {
    setOpenPrint3461Dialog(false)
  }

  const handleDelete = () => {
    setLoading(true);

    fetch(AbiEntrySummaryApiUrls.DELETE+`?abiTransId=${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
      },
    }).then(res => res.json())
        .then(json => {
          setLoading(false);
          if (!!json.data) {
            setOpenDeleteDialog(false)
            handleClose();
            fetchData();
          }
        })
        .catch(err => {
          setLoading(false);
          console.error(err);
        })
  }
  
  const handlePrintForm7501 = useCallback(async () => {
	setPrint7501Loading(true);
    const formData = new FormData();
    formData.append('abiTransId', id);
    formData.append('paymentMethod', print7501FormData.paymentMethod);
    formData.append('summaryDate', print7501FormData.summaryDate);
    formData.append('signatureDate', print7501FormData.signatureDate);
    formData.append('declarationParty', print7501FormData.declarationParty);
    formData.append('declarationMerchandise', print7501FormData.declarationMerchandise);

    const response = await fetch(AbiEntrySummaryApiUrls.DOWNLOAD_FORM_7501, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
      },
      body: formData
    });
    
    setPrint7501Loading(false);
    
    if (!response.ok) {
      const responseBody = await response.json(); // Parse the JSON body
      setErrorMessage(responseBody?.message || 'Error generating Form 7501');
      setShowErrorSnackbar(true);
      return;
    }

    // Extract filename from headers
    const contentDisposition = response.headers.get('Content-Disposition');
    let fileName = 'Form_7501_' + id + '.pdf';
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        fileName = decodeURIComponent(match[1]);
      }
    }
    
    // Convert response to blob and trigger download
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }, [id, print7501FormData]);
  
  const handlePrintForm3461 = useCallback(async () => {
	setPrint3461Loading(true);
    const formData = new FormData();
    formData.append('abiTransId', id);
    formData.append('form3461Date', print3461FormData.form3461Date);

    const response = await fetch(AbiEntrySummaryApiUrls.DOWNLOAD_FORM_3461, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
      },
      body: formData
    });
    
    setPrint3461Loading(false);
    
    if (!response.ok) {
      const responseBody = await response.json(); // Parse the JSON body
      setErrorMessage(responseBody?.message || 'Error generating Form 3461');
      setShowErrorSnackbar(true);
      return;
    }

    // Extract filename from headers
    const contentDisposition = response.headers.get('Content-Disposition');
    let fileName = 'Form_3461_' + id + '.pdf';
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        fileName = decodeURIComponent(match[1]);
      }
    }
    
    // Convert response to blob and trigger download
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }, [id, print3461FormData]);
  
  // Handle keyboard navigation for accessibility
  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      handleClose();
    } else if (event.key === 'Tab') {
      // Ensure focus stays within the modal
      const dialog = dialogRef.current;
      if (dialog) {
        const focusableElements = dialog.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey) {
          // Shift + Tab
          if (document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          }
        } else {
          // Tab
          if (document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
          }
        }
      }
    }
  };

  return (
    <>
      {/* Error Snackbar - Only show when showErrorSnackbar is true */}
      <SnackBar
        title="Error"
        type="error"
        open={showErrorSnackbar}
        onClose={() => {
          setShowErrorSnackbar(false);
          setErrorMessage('');
        }}
        duration={8000}
      >
        {errorMessage || "Internal error occurred, please try again later."}
      </SnackBar>
      
      <Dialog
        onClose={handleClose}
        ref={dialogRef}
        PaperProps={{
          sx: {
            maxWidth: '100dvw',
            width: '100dvw',
            maxHeight: {
              xs: '100dvh',
              sm: '90vh',
            },
            m: {
              xs: 0,
              sm: 4,
            },
          },
        }}
        TransitionProps={{
          onEntered: () => {
            // Comprehensive cleanup of any remaining focused elements in main wrapper
            const mainWrapper = document.querySelector('.mainwrapper');
            if (mainWrapper) {
              // Find and blur any focused elements
              const focusedElements = mainWrapper.querySelectorAll(':focus');
              focusedElements.forEach((element) => {
                element.blur();
              });

              // Extra safety: blur any MUI buttons that might be retaining focus
              const muiButtons = mainWrapper.querySelectorAll(
                '.MuiButton-root, .MuiButtonBase-root',
              );
              muiButtons.forEach((button) => {
                if (document.activeElement === button) {
                  button.blur();
                }
              });
            }

            // Ensure focus is properly set in the modal
            setTimeout(() => {
              const dialog = dialogRef.current;
              if (dialog) {
                const firstFocusable = dialog.querySelector(
                  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
                );
                if (firstFocusable) {
                  firstFocusable.focus();
                }
              }
            }, 10);
          },
        }}
        disableEnforceFocus={false}
        disableAutoFocus={false}
        disableRestoreFocus={false}
        onKeyDown={handleKeyDown}
        aria-labelledby="view-entry-summary-modal-title"
        aria-describedby="view-entry-summary-modal-description"
        role="dialog"
        {...props}
      >
        <DialogTitle
          id="view-entry-summary-modal-title"
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
        >
          View Entry Summary
          <IconButton
            aria-label="Close view entry summary modal"
            onClick={handleClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
            title="Close modal"
          >
            <Box component={FontAwesomeIcon} icon={faTimes} sx={{ width: '1em' }} />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          id="view-entry-summary-modal-description"
          sx={{
            px: {
              xs: 2,
              sm: 4,
            },
          }}
        >
          <Box>
            <EditEntrySummary isEntrySummary readOnly id={id} />
          </Box>
        </DialogContent>

        <DialogActions sx={{ pt: 3 }}>
          <Buttons
            advance={
              <Button onClick={handleClose} variant="contained" title="Close modal">
                Okay
              </Button>
            }
            other={
              <>
                <Button variant="outlined" onClick={handleEdit} title="Edit this Entry Summary">
                  Edit
                </Button>
                <Button variant="outlined"
                        onClick={handleClone} title="Clone a copy of this Entry Summary"
                        disabled={loading}
                        endIcon={<FontAwesomeIcon icon={loading ? faSpinnerThird : nextIcon} width={10} spin={loading} />}>
                  Clone
                </Button>
                {rowData != null && rowData["3461Status"] == null && rowData["7501Status"] == null && (
                  <Button
                      variant="outlined"
                      onClick={handleDeleteDialog}
                      color="error"
                      title="Proceed with Caution: Delete this Entry Summary"
                  >
                    Delete
                  </Button>
                )}
                <Button 
                  variant="outlined" 
                  icon={faDownload}
                  onClick={handlePrint7501Dialog} 
                  title="Generate Form 7501">
                  Form 7501
                </Button>
                <Button 
                  variant="outlined" 
                  icon={faDownload}
                  onClick={handlePrint3461Dialog} 
                  title="Generate Form 3461">
                  Form 3461
                </Button>
              </>
            }
          />
        </DialogActions>
      </Dialog>

      <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <DialogTitle>Are you sure you want to delete this record?</DialogTitle>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
          <Button onClick={handleDelete}
                  color="error"
                  disabled={loading}
                  endIcon={<FontAwesomeIcon icon={loading ? faSpinnerThird : nextIcon} width={10} spin={loading} />}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      
      <Dialog open={openPrint7501Dialog} onClose={() => setOpenPrint7501Dialog(false)}>
        <DialogTitle
          id="view-7501-print-options-title"
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
        >
          7501 Print Options
          <IconButton
            aria-label="Close 7501 print options"
            onClick={closePrint7501Dialog}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
            title="Close 7501 print options"
          >
            <Box component={FontAwesomeIcon} icon={faTimes} sx={{ width: '1em' }} />
          </IconButton>
        </DialogTitle>
        
        <DialogContent
          dividers
          id="view-7501-print-options-content"
          sx={{
            px: {
              xs: 2,
              sm: 4,
            },
          }}
        >
          <Box>
            <Print7501FormModal 
              id={id} 
              formData={print7501FormData}
              setFormData={setPrint7501FormData}
            />
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ pt: 3, justifyContent: 'center' }}>
          <Button 
                  variant="outlined" 
                  icon={faDownload}
                  onClick={handlePrintForm7501} 
                  disabled={print7501Loading}
                  endIcon={print7501Loading ? (<FontAwesomeIcon icon={faSpinnerThird} width={10} spin />) : null}
                  title="Generate Form 7501">
                  Print
          </Button>
        </DialogActions>
      </Dialog>
      
      <Dialog open={openPrint3461Dialog} onClose={() => setOpenPrint3461Dialog(false)}>
        <DialogTitle
          id="view-3461-print-options-title"
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
        >
          3461 Print Options
          <IconButton
            aria-label="Close 3461 print options"
            onClick={closePrint3461Dialog}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
            title="Close 3461 print options"
          >
            <Box component={FontAwesomeIcon} icon={faTimes} sx={{ width: '1em' }} />
          </IconButton>
        </DialogTitle>
        
        <DialogContent
          dividers
          id="view-3461-print-options-content"
          sx={{
            px: {
              xs: 2,
              sm: 4,
            },
          }}
        >
          <Box>
            <Print3461FormModal 
              id={id} 
              formData={print3461FormData}
              setFormData={setPrint3461FormData}
            />
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ pt: 3, justifyContent: 'center' }}>
          <Button 
                  variant="outlined" 
                  icon={faDownload}
                  onClick={handlePrintForm3461} 
                  disabled={print3461Loading}
                  endIcon={print3461Loading ? (<FontAwesomeIcon icon={faSpinnerThird} width={10} spin />) : null}
                  title="Generate Form 3461">
                  Print
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}